export default [{
  path: 'portal',
  name: 'portal',
  component: function component() {
    return import('@/views/portal/dashboard');
  }
}, {
  path: 'messageDetails',
  name: 'messageDetails',
  component: function component() {
    return import('@/components/main/messageDetails');
  }
}];